import { IconButton, Typography } from '@guildeducationinc/recess';
import ArrowForwardIcon from '@guildeducationinc/recess/icons/ArrowForwardIcon';
import { snakeCase } from 'lodash';
import { CAREER_PATHWAY_URL } from '@src/constants';
import { clickable } from '@src/analytics';
import './PathwayCard.scss';

interface PathwayCardProps {
  pathwayId: string;
  title: string;
  shortDescription: string;
}

const PathwayCard: React.FC<PathwayCardProps> = ({ pathwayId, title, shortDescription }) => {
  return (
    <a
      href={`${CAREER_PATHWAY_URL}/${pathwayId}`}
      className='cardAnchor'
      onClick={() =>
        clickable({
          product: 'home',
          loggedIn: true,
          tag: 'career_pathway_card',
          text: snakeCase(title),
          type: 'link',
        })
      }
      data-testid='pathway-card'
    >
      <div className='cardContainer'>
        <div className='cardContent'>
          <Typography className='heading' variant='h5' Component='h3'>
            {title}
          </Typography>
          <Typography variant='body1'>{shortDescription}</Typography>
        </div>
        <IconButton
          appearance='minimal'
          className='cardButton'
          icon={<ArrowForwardIcon size={32} />}
          label='Go to pathway'
        />
      </div>
    </a>
  );
};

export default PathwayCard;
